// extracted by mini-css-extract-plugin
export default {"editableImg":"style_editableImg__R7kd4","editableImgRelative":"style_editableImgRelative__MkJUc","buttons":"style_buttons__GqrPY","image":"style_image__Tks4s"};